import { CSSProperties } from "react";
import { TextConfig } from "../providers/QuizProvider/QuizContext";


export const getStyleFromTextConfig = (config?: TextConfig) => {
  const style: CSSProperties = {};
  if (config?.bold) style.fontWeight = "bold";
  if (config?.italic) style.fontStyle = "italic";
  if (config?.underline) style.textDecoration = "underline";
  return style;
};
